import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import FieldGroupShow from "./FieldGroupShow";
import FieldGroupOrderSettings from "./FieldGroupOrderSettings";
import { SchemaPropTypes } from "utils/propTypes";

const FieldGroupOrderHub = (props) => {
  const { name } = props;
  const { values } = useFormikContext();
  const modelsPath = `${name}.${STATE_KEYS.FORM.FIELD_GROUPS}`;
  const models = get(values, modelsPath, []);

  const activeIndex = get(values, STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX);
  const activeModel = models[activeIndex];
  const showModel = Boolean(activeModel);

  let content = null;

  if (showModel) {
    content = <FieldGroupShow {...props} />;
  } else {
    content = <FieldGroupOrderSettings {...props} />;
  }

  return content;
};

FieldGroupOrderHub.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.shape(SchemaPropTypes)
};

export default FieldGroupOrderHub;
